$(document).ready(function () {
  // Close all accordions except the first one
  $(".product__accordion details")
    .not(":first")
    .removeAttr("open")
    .removeClass("is-open");
  $(".product__accordion details:first").attr("open", true).addClass("is-open");

  // all close
  // $(".product__accordion details > summary").on("click", function (e) {
  //   var $details = $(this).parent();

  //   // If already open, let it close naturally
  //   if ($details.attr("open")) {
  //     setTimeout(function () {
  //       $details.removeAttr("open");
  //       $details.removeClass("is-open");
  //     }, 100); // Wait for native close
  //   } else {
  //     // Close all others
  //     $(".product__accordion details")
  //       .removeAttr("open")
  //       .removeClass("is-open");
  //     // Open this one
  //     setTimeout(function () {
  //       $details.attr("open", true).addClass("is-open");
  //     }, 100); // Wait for native open
  //   }
  // });

  // all open 
  $(".product__accordion details > summary").on("click", function (e) {
  var $details = $(this).parent();

  // Toggle current accordion only
  if ($details.attr("open")) {
    // If it's already open, close it
    setTimeout(function () {
      $details.removeAttr("open").removeClass("is-open");
    }, 100);
  } else {
    // If it's closed, open it without affecting others
    setTimeout(function () {
      $details.attr("open", true).addClass("is-open");
    }, 100);
  }
});


  setTimeout(function () {
    $("body p.hulk-powered-wrapper.text-right").hide();
  }, 1000);

  const $termsCheckbox = $("#RegisterForm-texts");
  const $submitButton = $("#RegisterForm-submit");

  // Disable the button if the checkbox is not checked
  $termsCheckbox.on("change", function () {
    if ($(this).is(":checked")) {
      $submitButton.prop("disabled", false); // Enable the button
      $(this).removeClass("error"); // Remove error class
    } else {
      $submitButton.prop("disabled", true); // Disable the button
      $(this).addClass("error"); // Add error class
    }
  });

  // Add validation on form submission
  $("#create_customer").on("submit", function (e) {
    if (!$termsCheckbox.is(":checked")) {
      e.preventDefault(); // Prevent form submission
      $termsCheckbox.addClass("error"); // Highlight the checkbox
    }
  });

  const hiddenIcon = $(".password-hidden");
  const visibleIcon = $(".password-visible");
  const passwordField = $("#RegisterForm-password"); // Replace with your actual password field ID

  // Initially hide the visible icon
  visibleIcon.hide();

  // Add click event for the hidden icon
  hiddenIcon.on("click", function () {
    passwordField.attr("type", "text"); // Show password
    hiddenIcon.addClass("hide-eye").hide(); // Add class and hide the hidden icon
    visibleIcon.removeClass("hide-eye").addClass("show-eye").show(); // Add class and show the visible icon
  });

  // Add click event for the visible icon
  visibleIcon.on("click", function () {
    passwordField.attr("type", "password"); // Hide password
    visibleIcon.removeClass("show-eye").hide(); // Remove class and hide the visible icon
    hiddenIcon.removeClass("hide-eye").show(); // Show the hidden icon
  });

  $("label.checkbox-input").on("click", function (e) {
    var checkbox = $(this).find('input[type="checkbox"]');
    checkbox.prop("checked", !checkbox.prop("checked"));
  });

  // Interval for updating the "One Time Purchase" label
  var intervalLabelBold = setInterval(function () {
    const $labelElement = $(".onetime-radio .rc-radio__label");

    if ($labelElement.length) {
      const fullText = $labelElement.text();

      if (fullText.startsWith("One Time Purchase")) {
        const suffixOne = fullText.replace("One Time Purchase", "").trim();
        $labelElement.html(
          `One Time Purchase - <span class="bold-onetime-text">${suffixOne}</span>`
        );
      }

      // Clear interval once the update is done
      clearInterval(intervalLabelBold);
    }
  }, 100);

  // Interval for updating the "Subscription" price
  var intervalPriceBold = setInterval(function () {
    const $priceElementSub = $(".subscription-radio .rc-radio__price");

    if ($priceElementSub.length) {
      const SubscriptionText = $priceElementSub.text().trim();
      $priceElementSub.html(`- ${SubscriptionText}`);

      // Clear interval once the update is done
      clearInterval(intervalPriceBold);
    }
  }, 100);

  let checkExist = setInterval(function () {
    if ($(".new-related-grid-wrapper").length) {
      clearInterval(checkExist);

      // Initialize Slick slider
      $(".new-related-grid-wrapper").slick({
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        centerPadding: "25%",
        slidesToScroll: 1,
        nextArrow: ".slide-right",
        prevArrow: ".slide-left",
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              infinite: true,
              dots: true,
            },
          },
        ],
      });

      console.log("Slick slider initialized");
    }
  }, 100); // Check every 100ms

  function initializeSlick() {
    const windowWidth = $(window).width();

    // Initialize .scientifically-award-slider only when necessary
    // console.log(windowWidth,"windowWidth---");

    if (windowWidth <= 989) {
      // console.log("yes---");
      if (!$(".scientifically-award-slider").hasClass("slick-initialized")) {
        $(".scientifically-award-slider").slick({
          dots: false,
          arrows: true,
          infinite: false,
          speed: 500,
          slidesToShow: 4,
          slidesToScroll: 1,
          autoplay: false,
          responsive: [
            {
              breakpoint: 990,
              settings: {
                slidesToShow: 3,
                arrows: true,
                dots: false,
              },
            },
            {
              breakpoint: 580,
              settings: {
                slidesToShow: 1,
                arrows: true,
                dots: false,
              },
            },
          ],
        });
      }
    } else {
      if ($(".scientifically-award-slider").hasClass("slick-initialized")) {
        $(".scientifically-award-slider").slick("unslick");
      }
    }

    // Initialize .collabs-page__images slider
    if (windowWidth <= 989) {
      if (!$(".collabs-page__images").hasClass("slick-initialized")) {
        $(".collabs-page__images").slick({
          dots: false,
          arrows: false,
          infinite: false,
          speed: 300,
          slidesToShow: 4,
          slidesToScroll: 4,
          responsive: [
            {
              breakpoint: 989,
              settings: {
                slidesToShow: 3.5,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
              },
            },
            {
              breakpoint: 749,
              settings: {
                slidesToShow: 2.5,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
              },
            },
            {
              breakpoint: 380,
              settings: {
                slidesToShow: 1.5,
                slidesToScroll: 1,
              },
            },
          ],
        });
      }
    } else {
      if ($(".collabs-page__images").hasClass("slick-initialized")) {
        $(".collabs-page__images").slick("unslick");
      }
    }

    // Initialize .slider-wrapper
    if (!$(".real-customer-slider-wrapper").hasClass("slick-initialized")) {
      $(".real-customer-slider-wrapper").slick({
        dots: false,
        arrows: true,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false,
        responsive: [
          {
            breakpoint: 990,
            settings: {
              slidesToShow: 2.5,
              arrows: true,
              dots: false,
            },
          },
          {
            breakpoint: 749,
            settings: {
              slidesToShow: 2,
              slidesToShow: 1.5,
              arrows: true,
              dots: false,
            },
          },
          {
            breakpoint: 580,
            settings: {
              slidesToShow: 1.5,
              arrows: true,
              dots: false,
            },
          },
          {
            breakpoint: 481,
            settings: {
              slidesToShow: 1,
              arrows: true,
              dots: false,
            },
          },
        ],
      });
    }

    // Initialize .slider-for and .slider-nav
    if (!$(".thumbnail-slider").hasClass("slick-initialized")) {
      $(".slider-for").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: false, // Try disabling fade to check for conflicts with infinite
        asNavFor: ".slider-nav",
        infinite: true, // Enable infinite looping
      });

      $(".slider-nav").slick({
        infinite: true, // Ensure infinite is true in the nav slider
        slidesToShow: 6,
        slidesToScroll: 1,
        vertical: true,
        asNavFor: ".slider-for",
        dots: false,
        arrows: true,
        focusOnSelect: true,
        verticalSwiping: true,
        responsive: [
          {
            breakpoint: 990,
            settings: {
              slidesToShow: 6,
              slidesToScroll: 1,
              verticalSwiping: false, // Disable vertical swiping for smaller screens
              horizontalSwiping: true, // Enable horizontal swiping for smaller screens
              vertical: false, // Disable vertical orientation for smaller screens
            },
          },
        ],
      });
    }
  }
  initializeSlick();
  if ($(window).width() <= 580) {
    $(".scientifically-award-slider .logo-image").css({
      visibility: "hidden",
      opacity: 0,
    });
    $(".scientifically-award-slider .logo-image:first-child").css({
      visibility: "visible",
      opacity: 1,
    });
  }

  // Ensure Slick initializes after the page fully loads
  $(window).on("load", function () {
    setTimeout(function () {
      console.log("Re-initialize load");
      initializeSlick(); // Initialize the slider after all resources are loaded with a small delay
      $(window).trigger("resize");
      if ($(window).width() <= 580) {
        setTimeout(function () {
          $(".scientifically-award-slider .logo-image").css({
            visibility: "visible",
            opacity: 1,
          });
        }, 150);
      }
    }, 150);
    // }, 300);
    // Adding a slight delay ensures elements like images are fully loaded
  });

  // Handle window resize events
  let resizeTimeout;
  $(window).on("resize", function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function () {
      console.log("Re-initialize");
      initializeSlick(); // Re-initialize slider on resize after a delay
    }, 100); // Delay for smoother resize handling
    // }, 250); // Delay for smoother resize handling
  });
  // Close all accordions except the first one
  // $(".product__accordion details").not(":first").removeAttr("open");
  // $(".product__accordion details:first").addClass("is-open");

  // // When an accordion is clicked
  // $(".product__accordion details").on("click", function () {
  //   // Close all accordions except the one being clicked
  //   $(".product__accordion details").not(this).removeAttr("open");
  // });
  $(document).on("click", ".search-link", function () {
    $(this)
      .parents(".header-section")
      .find("summary.header_icon--search")
      .trigger("click");
  });
  $(".new-related-products .add-to-cart-button").text("Add");
});

document.addEventListener("DOMContentLoaded", () => {
  const backToTopFunction = function () {
    let backToTop = document.getElementById("back-to-top-button");
    let stickyAtcBar = document.getElementById("sticky-atc-bar");
    let mobileaddtocartbuttom = document.getElementById("mobile-add-to-cart");

    if (backToTop) {
      backToTop.addEventListener("click", () => {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
      });

      window.addEventListener("scroll", () => {
        if (window.scrollY >= 700) {
          backToTop.classList.add("active");
        } else {
          backToTop.classList.remove("active");
        }
      });
    }

    if (mobileaddtocartbuttom) {
      mobileaddtocartbuttom.addEventListener("click", () => {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
      });

      window.addEventListener("scroll", () => {
        if (window.scrollY >= 1150) {
          mobileaddtocartbuttom.classList.add("active");
        } else {
          mobileaddtocartbuttom.classList.remove("active");
        }
      });
    }
  };

  document.addEventListener("shopify:section:load", function (event) {
    backToTopFunction();
  });

  backToTopFunction();

  const stickyBarFunctionality = function () {
    let stickyBar = document.getElementById("sticky-atc-bar");
    if (stickyBar) {
      window.addEventListener("scroll", scrollFunctions);
      function scrollFunctions() {
        if (window.scrollY >= 700) {
          stickyBar.style.opacity = "1";
          stickyBar.style.visibility = "visible";
        } else {
          stickyBar.style.opacity = "0";
          stickyBar.style.visibility = "hidden";
        }
      }
    }
  };

  const mobilestickyBarFunctionality = function () {
    let mobileaddtocartbuttom = document.getElementById("sticky-atc-bar");
    window.addEventListener("scroll", scrollFunctions);
    if (mobileaddtocartbuttom) {
      function scrollFunctions() {
        if (window.scrollY >= 750) {
          mobileaddtocartbuttom.style.opacity = "1";
          mobileaddtocartbuttom.style.visibility = "visible";
        } else {
          mobileaddtocartbuttom.style.opacity = "0";
          mobileaddtocartbuttom.style.visibility = "hidden";
        }
      }
    }
  };

  // reload JS on section update
  document.addEventListener("shopify:section:load", function (event) {
    stickyBarFunctionality();
    mobilestickyBarFunctionality();
  });
  // load JS on page load
  stickyBarFunctionality();
  mobilestickyBarFunctionality();

  function initBackToTop() {
    var amountScrolled = 100;
    const mobileAddToCart = document.querySelector("#mobile-add-to-cart");
    if (mobileAddToCart) {
      // Show or hide the mobile add-to-cart button based on scroll position
      window.addEventListener("scroll", function () {
        if (window.scrollY > amountScrolled) {
          mobileAddToCart.classList.add("show");
        } else {
          mobileAddToCart.classList.remove("show");
        }
      });

      // Add click event to mobile add-to-cart button to scroll to the product-form__buttons section
      mobileAddToCart.addEventListener("click", function (e) {
        e.preventDefault();

        // Find the product-form__buttons section
        const productFormButtons = document.querySelector(
          ".product-form__buttons"
        );

        if (productFormButtons) {
          // Scroll smoothly to the product-form__buttons section
          window.scrollTo({
            top: productFormButtons.offsetTop, // Scroll to the top of the product-form__buttons section
            behavior: "smooth",
          });
        }
      });
    }
  }

  // Initialize the back-to-top functionality
  initBackToTop();

  // Re-initialize if in Shopify design mode (to reload on section updates)
  if (Shopify.designMode) {
    document.addEventListener("shopify:section:load", function (event) {
      initBackToTop();
    });
  }

  document.querySelector(".mb-icon").addEventListener("click", function () {
    var menuDraweropen = document.getElementById(
      "Details-menu-drawer-container"
    );

    if (menuDraweropen.classList.contains("menu-opening")) {
      menuDraweropen.classList.remove("menu-opening"); // Hide menu by removing class
    } else {
      menuDraweropen.classList.add("menu-opening"); // Show menu by adding class
    }
  });
  const checkForSubscriptionWidget = setInterval(() => {
    // Check if the element with class 'recharge-subscription-widget' exists
    if (document.querySelector(".recharge-subscription-widget")) {
      // Now that the element is loaded, proceed with your code
      const oneTimePriceLabel = document.querySelector(
        'label[for="rc-radio1"] .rc-radio__label'
      );
      const subscriptionPriceLabel = document.querySelector(
        'label[for="rc-radio2"] .rc-radio__price'
      );

      if (oneTimePriceLabel) {
        clearInterval(checkForSubscriptionWidget); // Stop checking once the element is found
        const originalOneTimeText = oneTimePriceLabel.textContent.trim();
        const updatedOneTimeText = originalOneTimeText.replace(
          /(\$[0-9,.]+ [A-Z]+)/,
          "- <strong>$1</strong>"
        );
        oneTimePriceLabel.innerHTML = updatedOneTimeText; // Use innerHTML to insert HTML tags
      }

      if (subscriptionPriceLabel) {
        clearInterval(checkForSubscriptionWidget);
        const originalSubscriptionText =
          subscriptionPriceLabel.textContent.trim();
        const updatedSubscriptionText = originalSubscriptionText.replace(
          /(\$[0-9,.]+)/,
          " - <strong>$1</strong>"
        );
        subscriptionPriceLabel.innerHTML = updatedSubscriptionText; // Use innerHTML to insert HTML tags
      }
    }
  }, 1500); // Check every 1500ms until the class is detected

  // blog/article js

  function resetTags() {
    $(".blog-search__tag").each(function (index) {
      if (index < 5) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });
    $(".blog-search__all-tags").show().html("See All Tags");
  }

  $(".blog-search__all-tags").on("click", function () {
    if ($(this).hasClass("blog-search__all-tags--active")) {
      resetTags(); // Hide tags or reset the state
      $(this).removeClass("blog-search__all-tags--active").html("See All");
    } else {
      $(".blog-search__tag").show(); // Show all tags
      $(this).addClass("blog-search__all-tags--active").html("See Less");
    }
  });
});